import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { nanoid } from "nanoid";
import store from "@/store";
import { Dialog } from "vant";
import { getSelectList } from "@/api/common";
import {
  UIS_AUTH_URL,
  TRACE_LOG_URL,
  SYSTEM_FLAG,
  SESSION_STORAGE_FINGER,
  LOCAL_STORAGE_TRACE_ID,
  HEADER_TOKEN_NAME,
  DICT_THIRD_PLATFORM_INT_TEST,
  STATUS_CODE_OK,
} from "@/config";
// 手机号码正则验证
export const validationMobilePhone = (number) => {
  return /(^1[1|2|3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/.test(number);
};
// 邮箱正则验证
export const validationEmail = (email) => {
  return /(^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$)/.test(
    email
  );
};

// 身份证正则校验
export const validationIdentityCard = (number) => {
  if (number) {
    number = number.toString();
    if (number.length === 15 || number.length === 18) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

// 获取sessionStorage
export const getSessionStorage = (key) => {
  if (window.sessionStorage.getItem(key)) {
    return JSON.parse(window.sessionStorage.getItem(key));
  } else {
    return null;
  }
};
// 设置sessionStorage
export const setSessionStorage = (key, val) => {
  window.sessionStorage.setItem(key, JSON.stringify(val));
};
// 清除sessionStorage
export const clearSessionStorage = (key) => {
  window.sessionStorage.removeItem(key);
};
// 获取localStorage
export const getLocalStorage = (key) => {
  if (window.localStorage.getItem(key)) {
    return JSON.parse(window.localStorage.getItem(key));
  } else {
    return null;
  }
};
// 设置localStorage
export const setLocalStorage = (key, val) => {
  window.localStorage.setItem(key, JSON.stringify(val));
};
// 清除localStorage
export const clearLocalStorage = (key) => {
  window.localStorage.removeItem(key);
};

// replaceAll
export const replaceAll = (str, key, val) => {
  return str.replace(new RegExp(key, "g"), val || "");
};

// 时间控件格式化
export const dateTimeFormatter = (type, val) => {
  if (type === "year") {
    return `${val}年`;
  } else if (type === "month") {
    return `${val}月`;
  } else if (type === "day") {
    return `${val}日`;
  } else if (type === "hour") {
    return `${val}时`;
  } else if (type === "minute") {
    return `${val}分`;
  } else {
    return val;
  }
};

// url动态添加参数
export const queryStringParameter = (uri, key, value) => {
  if (!value) {
    return uri;
  }
  let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  let separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
};

// 需要登录检查
export const hasLoginCheck = async (param) => {
  let nowParam = {
    path: "/",
    tip: "请先登录",
    callBack: null,
  };
  if (param) {
    nowParam = { ...nowParam, ...param };
  }
  if (!store.getters.token) {
    // 用户没有登录先去登录
    try {
      await Dialog.confirm({
        title: "提示",
        message: nowParam.tip,
        confirmButtonText: "去登录",
        cancelButtonText: "关闭",
        confirmButtonColor: "#1989fa",
      });
      if (process.env.VUE_APP_IS_WXAUTH === "Y") {
        window.location.replace(
          `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
            nowParam.path
          )}&openId=${store.getters.openId}`
        );
      } else {
        window.location.replace(
          `${UIS_AUTH_URL}&path=${window.encodeURIComponent(nowParam.path)}`
        );
      }
    } catch (err) {
      console.log(err);
    }
  } else {
    nowParam.callBack && nowParam.callBack();
  }
};

// 是否还有更多数据检查
export const listHasMore = (param) => {
  let nowParam = {
    pageNo: 1,
    pageSize: 10,
    totalCount: 0,
  };
  if (param) {
    nowParam = { ...nowParam, ...param };
  }
  const { pageNo, pageSize, totalCount } = nowParam;
  return pageNo * pageSize < totalCount;
};

// 获取样式属性
export const getStyle = (Element, Property) => {
  return Element.currentStyle
    ? Element.currentStyle[Property]
    : getComputedStyle(Element)[Property];
};

// SelectListToMap
export const SelectListToMap = (list) => {
  let obj = {};
  for (let i = 0, len = list.length; i < len; i++) {
    let item = list[i];
    obj[item.value] = item.label;
  }
  return obj;
};

// 去掉富文本格式
export const removeRickFormat = (str) => {
  str = str.replace(/<\/?[^>]*>/g, ""); //匹配所有html标签

  str = str.replace(/<p[^>]*>/g, '<p class="tag-class">'); //去除标签内所有属性，并设置自定义类名

  str = str.replace(/(\n)/g, ""); //去除换行

  str = str.replace(/\s+style="[^"]*"/g, ""); //去除style样式

  str = str.replace(/&nbsp;/gi, ""); //去除空格

  str = str.replace(/<img/gi, '<img class="img_class"'); //添加自定义样式

  return str;
};

// 当前测试是否可以测试
export const nowUserCanTest = async () => {
  let canTest = false;
  const { data } = await getSelectList({
    dictTable: DICT_THIRD_PLATFORM_INT_TEST,
  });
  if (data.code === STATUS_CODE_OK) {
    const openIds = data.data.find(
      (item) => item.value == "SHRFIDTESTUSERS"
    ).label;
    if (!openIds) {
      canTest = true;
    } else {
      const openIdList = openIds.split(",");
      canTest = openIdList.includes(store.getters.openId);
    }
  }
  if (!canTest) {
    Dialog.alert({
      title: "提示",
      message: "当前功能系统维护中，请稍后再试",
    });
  }
  return canTest;
};

// 日志上报
export const logTrace = async (param) => {
  if (process.env.VUE_APP_IS_TRACE_LOG === "Y") {
    // 获取设备指纹
    let deviceFingerPrint = getSessionStorage(SESSION_STORAGE_FINGER);
    if (!deviceFingerPrint) {
      const fp = await FingerprintJS.load();
      const fpRes = await fp.get();
      deviceFingerPrint = fpRes.visitorId;
      setSessionStorage(SESSION_STORAGE_FINGER, deviceFingerPrint);
    }
    // 获取traceId
    let frontTraceId = getLocalStorage(LOCAL_STORAGE_TRACE_ID);
    if (!frontTraceId) {
      frontTraceId = nanoid(32);
      setLocalStorage(LOCAL_STORAGE_TRACE_ID, frontTraceId);
    }
    const paramInit = {
      requestUrl: "", // 当前页面url
      rquestUrlName: "", // 当前页面名称
      holdTime: "", // 当前页面停留时长
      prefixUrl: "", // 前一页面url
      prefixUrlName: "", // 前一页面名称
      actionType: "", // 动作类型
      actionTypeCode: "", // 动作类型id
      actionTypeDesc: "", // 动作类型描述
      requestParams: {}, // 请求参数
      frontTraceId, // 用户本地唯一标识
      clientChannel: SYSTEM_FLAG, // 来源渠道
      userAgent: window.navigator.userAgent, // 浏览器信息
      deviceLang: window.navigator.language, // 浏览器语言
      deviceFingerPrint, // 客户端设备指纹
      deviceDisplayWidth: window.screen.width, // 客户端设备宽
      deviceDisplayHeight: window.screen.height, // 客户端设备高
    };
    const paramPost = { ...paramInit, ...param };
    axios.post(TRACE_LOG_URL, paramPost, {
      baseURL: process.env.VUE_APP_BACK_END_API_PX_URL,
      headers: {
        [HEADER_TOKEN_NAME]: store.getters.token,
      },
    });
  }
};
